// The marketplace entry the shopper arrived through, stamped on the Rails shell.
// The app is a MemoryRouter, so the path is gone after boot and every request
// that needs the marketplace has to carry it itself.
export const getMarketplaceSlug = (): string | undefined =>
  document.getElementById("root")?.dataset.marketplace || undefined;
